import {
	get,
	post,
	postForm
} from '../axios-req.js'
post
get
postForm
export const testPageApi = {
	// 获取题目
	selectQuestionnaireInfo: (data) => {
		return post('/questionnaire/getQuestionnaireInfo', data);
	},
	
	
	
	// 获取用户信息和问卷信息
	selectUserInfo: (data) => {
		return get('/questionnaire/userInfo', data);
	},
	// 获取默认分类问卷信息（维度分类）
	selectDefaultQuestion: (data) => {
		return get('/questionnaire/defaultQuestion', data);
	},
	// 获取用户分类后的问卷信息（自定义分类）
	selectUserDefinedQuestion: (data) => {
		return get('/questionnaire/userDefinedQuestion', data);
	},
	
	// 分类列表
	selectClassify: (data) => {
		return get('/questionnaire/getClassify', data);
	},
	// 新增分类
	selectCreateClassify: (data) => {
		return postForm('/questionnaire/createClassify', data);
	},
	// 修改分类
	selectUpdateClassify: (data) => {
		return postForm('/questionnaire/updateClassify', data);
	},
	// 删除分类
	selectDeleteClassify: (data) => {
		return postForm('/questionnaire/deleteClassify', data);
	},
	// 分配问题到部门
	selectAllocationIssues: (data) => {
		return postForm('/questionnaire/allocationIssues', data);
	},
	// 查看文件
	getSeeFileUrl: (data) => {
		return get('questionnaire/downloadFile', data);
	},
}
